export default "__VITE_ASSET__D2Pp2I$S__";